export const testColumns = [
  {
    data: "doorStatus",
    title: "Actions",
    active: true,
    canToggle: false
  },
  {
    data: "dockDoorName",
    title: "Dock Door Name",
    active: true,
    canToggle: true
  },
  {
    data: "doorUses",
    title: "Door Uses",
    active: true,
    canToggle: true
  },
  {
    data: "appointmentTypes",
    title: "Appointment Types",
    active: true,
    canToggle: true
  },
  {
    data: "dockStatus",
    title: "Status",
    active: true,
    canToggle: true
  },
  {
    data: "scheduleType",
    title: "Schedule Type",
    active: true,
    canToggle: true
  },
  {
    data: "dateModified",
    title: "Date Modified",
    active: true,
    canToggle: false
  },
  {
    data: "modifiedBy",
    title: "Modified By",
    active: true,
    canToggle: true
  }
];


// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/html/doorLookup/stores/testColumnModalData.js